export const registerForm = () => ({
  businessCustomer: true,
  onSelectBusinessCustomer() {
    this.businessCustomer = true;
    document.querySelector('[id="company"]').removeAttribute('disabled');
  },
  onSelectPrivateCustomer() {
    this.businessCustomer = false;
    document
      .querySelector('[id="company"]')
      .setAttribute('disabled', 'disabled');
  },
});
